import Quill from 'quill';
const BlockEmbed = Quill.import('blots/block/embed');

class PageBreakBlot extends BlockEmbed {
  static blotName = 'pageBreak';
  static tagName = 'div';
  static className = 'ql-page-break'; // <-- restrict matching to this class

  static create() {
    const node = super.create();
    node.classList.add(PageBreakBlot.className);
    // optional niceties:
    node.setAttribute('contenteditable', 'false');
    node.setAttribute('data-page-break', 'true');
    return node;
  }
}

Quill.register(PageBreakBlot);
